import PrintListArea from "../print_list";

function TodoListArea(props: any) {
  let myProps = {
    todo_info_arr: [],
    print_options: {},
    ...props
  };
  let todo_info_arr = myProps.todo_info_arr;
  const get_print_list_tags = () => {
    let print_list_tags = todo_info_arr.map((todo_info: any, idx: number) => {
      return (
        <PrintListArea
          key={idx}
          todo_info={todo_info}
          print_options={myProps.print_options}
        ></PrintListArea>
      );
    });
    return print_list_tags;
  };

  return (
    <>
      {get_print_list_tags()}
    </>
  );
};
export default TodoListArea;